var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1824.64 501.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#purple);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 24.11,
    y1: 470.21,
    x2: 379.22,
    y2: 470.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#290760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2d0a67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3a147b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4e249c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5f32b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 64.34,
    y1: 438.29,
    x2: 225.07,
    y2: 127.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#6235b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#693cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7c50cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9c71e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#a479e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 432.04,
    y1: 437.61,
    x2: 290.57,
    y2: 186.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 165.22,
    y1: 411.81,
    x2: 498.55,
    y2: 411.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a479e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6235b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purple",
    x1: 645.92,
    y1: 250.9,
    x2: 1824.64,
    y2: 250.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#6235b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#693cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7c50cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9c71e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#a479e8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.22,498.85s-24.89-54.17-67.11-57.28c-.44.44-288,0-288,0l12.44,57.28h342.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.88,42.4l30.67,53.33L63.11,450.85s-12.89,25.22,25.33,48H31.14c-1.61,0-3.19-.35-4.66-1.02-8.61-3.93-36.63-19.43-22.62-49.72,1.33,0,233.03-405.71,233.03-405.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "437.66 498.85 498.55 498.85 295.44 147.35 267 201.57 437.66 498.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.22,376.68s18.22-56.89,68.44-51.56c.77.77,88.7-.09,112.97-.34,5.31-.06,10.6.6,15.72,2.02,13.31,3.7,37.99,13.47,57.9,37.9.9,1.11,1.69,2.3,2.4,3.53,9.01,15.73,75.89,130.61,75.89,130.61h-61.33l-47.33-81.39c-28.89-31.56-41.33-33.78-58.33-37.25-9.9-2.03-24.31-2.52-44.56-2.19l-121.78-1.33Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M804.18,160.79c-.7,10.92-3.05,20.75-7.07,29.48-4.02,8.74-9.4,16.18-16.15,22.33-6.75,6.16-14.79,10.89-24.12,14.22-9.33,3.32-19.65,4.99-30.97,4.99-12.8,0-24.17-2.36-34.09-7.07-9.93-4.71-18.26-11.31-25.01-19.8-6.75-8.49-11.91-18.68-15.48-30.59-3.57-11.91-5.36-25.01-5.36-39.3v-29.18c0-14.39,1.88-27.54,5.66-39.45,3.77-11.91,9.13-22.13,16.08-30.67,6.95-8.54,15.36-15.16,25.23-19.88,9.88-4.71,20.97-7.07,33.27-7.07s22.5,1.69,31.79,5.06c9.28,3.38,17.2,8.19,23.75,14.44,6.55,6.25,11.71,13.9,15.48,22.93,3.77,9.03,6.15,19.2,7.15,30.52h-41.69c-.4-6.45-1.37-12.11-2.9-16.97-1.54-4.86-3.77-8.91-6.7-12.13-2.93-3.22-6.6-5.66-11.02-7.29-4.42-1.64-9.7-2.46-15.86-2.46s-12.06,1.39-16.82,4.17c-4.76,2.78-8.71,6.85-11.84,12.21s-5.43,11.94-6.92,19.73c-1.49,7.79-2.23,16.65-2.23,26.58v29.48c0,21.34,3,37.12,9.01,47.34,6,10.22,15.51,15.33,28.51,15.33,10.92,0,19.55-2.9,25.9-8.71,6.35-5.81,9.87-15.21,10.57-28.21h41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M820.27,146.64c0-11.71,1.69-22.55,5.06-32.53,3.37-9.97,8.31-18.63,14.81-25.98,6.5-7.34,14.44-13.1,23.82-17.27,9.38-4.17,20.12-6.25,32.23-6.25s22.88,2.08,32.31,6.25c9.43,4.17,17.39,9.93,23.89,17.27,6.5,7.35,11.44,16,14.81,25.98,3.37,9.97,5.06,20.82,5.06,32.53v3.13c0,11.81-1.69,22.7-5.06,32.68-3.38,9.97-8.29,18.63-14.74,25.98-6.45,7.35-14.39,13.08-23.82,17.2-9.43,4.12-20.15,6.18-32.16,6.18s-22.9-2.06-32.38-6.18c-9.48-4.12-17.47-9.85-23.97-17.2-6.5-7.34-11.44-16-14.81-25.98-3.38-9.98-5.06-20.87-5.06-32.68v-3.13ZM861.65,149.77c0,6.75.64,13.08,1.94,18.98,1.29,5.91,3.32,11.07,6.1,15.48,2.78,4.42,6.38,7.92,10.79,10.5,4.42,2.58,9.75,3.87,16,3.87s11.26-1.29,15.63-3.87c4.37-2.58,7.91-6.08,10.64-10.5,2.73-4.42,4.74-9.58,6.03-15.48,1.29-5.9,1.94-12.23,1.94-18.98v-3.13c0-6.55-.65-12.75-1.94-18.61-1.29-5.85-3.3-11.02-6.03-15.48-2.73-4.47-6.28-7.99-10.64-10.57-4.37-2.58-9.68-3.87-15.93-3.87s-11.41,1.29-15.78,3.87c-4.37,2.58-7.94,6.1-10.72,10.57-2.78,4.47-4.82,9.63-6.1,15.48-1.29,5.86-1.94,12.06-1.94,18.61v3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1034.21,67.59l2.53,22.33c5.76-8.04,12.75-14.27,20.99-18.68,8.24-4.42,17.37-6.62,27.39-6.62,8.14,0,15.58,1.19,22.33,3.57,6.75,2.38,12.58,6.18,17.49,11.39,4.91,5.21,8.73,11.91,11.46,20.1,2.73,8.19,4.09,18.14,4.09,29.85v99.15h-41.39v-98.56c0-6.35-.72-11.59-2.16-15.71-1.44-4.12-3.5-7.37-6.18-9.75-2.68-2.38-5.91-4.04-9.68-4.99-3.77-.94-8.04-1.42-12.8-1.42-7.05,0-13.05,1.42-18.01,4.24-4.96,2.83-8.98,6.73-12.06,11.69v114.49h-41.54V67.59h37.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1243.4,28.14v39.45h60.15v30.52h-60.15v69.23c0,5.86.67,10.74,2.01,14.66,1.34,3.92,3.25,7.05,5.73,9.38,2.48,2.33,5.48,4,9.01,4.99,3.52.99,7.47,1.49,11.84,1.49,3.18,0,6.43-.15,9.75-.45,3.32-.3,6.5-.67,9.53-1.12,3.03-.45,5.85-.92,8.49-1.41,2.63-.5,4.89-.99,6.77-1.49l4.02,28.43c-2.88,1.69-6.25,3.15-10.12,4.39-3.87,1.24-7.99,2.26-12.36,3.05-4.37.79-8.91,1.41-13.62,1.86-4.72.45-9.36.67-13.92.67-8.83,0-16.85-1.17-24.04-3.5-7.2-2.33-13.35-5.96-18.46-10.87-5.11-4.91-9.06-11.17-11.84-18.76-2.78-7.59-4.17-16.7-4.17-27.32v-73.25h-36.77v-30.52h36.77V28.14h41.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1453.92,64.61c6.25,0,12.03.42,17.34,1.27,5.31.84,9.6,1.76,12.88,2.75l-6.1,41.24c-5.46-1.29-11.04-2.26-16.75-2.9-5.71-.64-11.14-.97-16.3-.97-11.61,0-20.92,2.23-27.91,6.7-7,4.47-12.23,10.87-15.71,19.21v96.77h-41.39V67.59h38.56l1.94,26.35c6.55-9.13,14.39-16.3,23.52-21.51,9.13-5.21,19.1-7.82,29.92-7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1503.36,146.64c0-11.71,1.69-22.55,5.06-32.53,3.37-9.97,8.31-18.63,14.81-25.98,6.5-7.34,14.44-13.1,23.82-17.27,9.38-4.17,20.12-6.25,32.23-6.25s22.88,2.08,32.31,6.25c9.43,4.17,17.39,9.93,23.89,17.27,6.5,7.35,11.44,16,14.81,25.98,3.37,9.97,5.06,20.82,5.06,32.53v3.13c0,11.81-1.69,22.7-5.06,32.68-3.38,9.97-8.29,18.63-14.74,25.98-6.45,7.35-14.39,13.08-23.82,17.2-9.43,4.12-20.15,6.18-32.16,6.18s-22.9-2.06-32.38-6.18c-9.48-4.12-17.47-9.85-23.97-17.2-6.5-7.34-11.44-16-14.81-25.98-3.38-9.98-5.06-20.87-5.06-32.68v-3.13ZM1544.75,149.77c0,6.75.64,13.08,1.94,18.98,1.29,5.91,3.32,11.07,6.1,15.48,2.78,4.42,6.38,7.92,10.79,10.5,4.42,2.58,9.75,3.87,16,3.87s11.26-1.29,15.63-3.87c4.37-2.58,7.91-6.08,10.64-10.5,2.73-4.42,4.74-9.58,6.03-15.48,1.29-5.9,1.94-12.23,1.94-18.98v-3.13c0-6.55-.65-12.75-1.94-18.61-1.29-5.85-3.3-11.02-6.03-15.48-2.73-4.47-6.28-7.99-10.64-10.57-4.37-2.58-9.68-3.87-15.93-3.87s-11.41,1.29-15.78,3.87c-4.37,2.58-7.94,6.1-10.72,10.57-2.78,4.47-4.82,9.63-6.1,15.48-1.29,5.86-1.94,12.06-1.94,18.61v3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1688.42,0h90.07v195.03h46.15v33.65h-136.22v-33.65h48.24V33.79h-48.24V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M796.73,498.67h-41.39v-93.94h-61.34v93.94h-41.54v-216.76h41.54v88.88h61.34v-88.88h41.39v216.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M928.65,476.04c-5.46,8.04-12.04,14.34-19.73,18.91-7.69,4.56-16.1,6.85-25.23,6.85-8.34,0-15.98-1.29-22.93-3.87-6.95-2.58-12.9-6.67-17.87-12.28-4.96-5.61-8.81-12.75-11.54-21.44-2.73-8.68-4.09-19.13-4.09-31.34v-95.28h41.39v95.58c0,6.55.47,12.06,1.41,16.53.94,4.47,2.46,8.07,4.54,10.79,2.08,2.73,4.81,4.69,8.19,5.88,3.37,1.19,7.49,1.79,12.36,1.79,8.24,0,14.94-1.56,20.1-4.69,5.16-3.13,9.08-7.42,11.76-12.88v-113h41.54v161.08h-37.52l-2.38-22.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1141.85,419.77c0,12.01-1.32,23.03-3.95,33.05-2.63,10.03-6.58,18.66-11.84,25.9-5.26,7.25-11.81,12.88-19.65,16.9-7.84,4.02-16.97,6.03-27.39,6.03-9.43,0-17.59-1.76-24.49-5.29-6.9-3.52-12.83-8.46-17.79-14.81l-1.94,17.12h-37.22v-228.67h41.39v82.18c4.76-5.56,10.4-9.88,16.9-12.95,6.5-3.08,14.12-4.62,22.85-4.62,10.52,0,19.73,2.04,27.62,6.1,7.89,4.07,14.46,9.73,19.73,16.97,5.26,7.25,9.21,15.91,11.84,25.98,2.63,10.08,3.95,21.07,3.95,32.98v3.13ZM1100.46,416.64c0-6.55-.5-12.75-1.49-18.61-.99-5.85-2.71-10.99-5.14-15.41-2.43-4.42-5.73-7.91-9.9-10.5-4.17-2.58-9.38-3.87-15.63-3.87-7.54,0-13.67,1.59-18.39,4.76-4.72,3.18-8.36,7.54-10.94,13.1v64.17c2.58,5.56,6.23,9.93,10.94,13.1,4.71,3.18,10.94,4.76,18.68,4.76,6.25,0,11.41-1.21,15.48-3.65,4.07-2.43,7.32-5.81,9.75-10.12,2.43-4.32,4.14-9.43,5.14-15.33.99-5.9,1.49-12.33,1.49-19.28v-3.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlHub);
export default __webpack_public_path__ + "static/media/Control_Hub.5954158509802489dce0449dc01805d9.svg";
export { ForwardRef as ReactComponent };